import { useState } from "react";

import styles from "./PasswordInput.module.scss";
import TextInput from "../TextInput";

import { ReactComponent as NotEye } from "../../../assets/notEye.svg";
import { ReactComponent as Eye } from "../../../assets/eye.svg";

const PasswordInput = (props) => {
	const {
		onChange = () => {},
		className,
		placeholder,
		label,
		formatter,
		error,
		setError,
	} = props;

	const [isPwsVisible, setIsPwsVisible] = useState(false);

	return (
		<div className={`${styles.passwordInputContainer} ${className}`}>
			<TextInput
				type={isPwsVisible ? "text" : "password"}
				onChange={onChange}
				className={className}
				placeholder={placeholder}
				label={label}
				formatter={formatter}
				error={error}
				setError={setError}
			></TextInput>

			{isPwsVisible ? (
				<NotEye
					className={styles.passwordInputIcon}
					onClick={() => setIsPwsVisible(false)}
				/>
			) : (
				<Eye
					className={styles.passwordInputIcon}
					onClick={() => setIsPwsVisible(true)}
				/>
			)}
		</div>
	);
};

export default PasswordInput;
